import React, { useState } from 'react';
import './FAQ.scss';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      section: '🐕 Coaching canin',
      questions: [
        {
          question: 'Qu\'est-ce qu\'un coach canin ?',
          answer: 'Un coach canin aide les maîtres à comprendre et à éduquer leur chien grâce à des méthodes bienveillantes et adaptées à chaque animal.'
        },
        {
          question: 'Quels problèmes pouvez-vous résoudre avec mon chien ?',
          answer: 'J\'interviens pour les problèmes d\'éducation et de comportement : aboiements, destructions, anxiété de séparation, agressivité, propreté, marche en laisse, rappel, etc. Si la situation nécessite un suivi plus approfondi, je peux également vous orienter vers un comportementaliste.'
        },
        {
          question: 'Quelles méthodes utilisez-vous ?',
          answer: 'Mes méthodes sont respectueuses du chien et basées sur le renforcement positif.'
        },
        {
          question: 'Combien de séances faut-il pour voir des résultats ?',
          answer: 'Chaque chien est unique. Certains progrès sont visibles dès la première séance, mais un suivi régulier est conseillé pour des résultats durables.'
        },
        {
          question: 'À quel âge peut-on commencer l\'éducation d\'un chien ?',
          answer: 'Dès l\'arrivée du chiot, à partir de 2 mois. Mais il n\'est jamais trop tard : même un chien adulte peut apprendre de nouvelles habitudes.'
        },
        {
          question: 'Proposez-vous un accompagnement avant l\'adoption d\'un chien ?',
          answer: 'Oui, je propose des visites et des conseils personnalisés avant l\'adoption. Cela permet de préparer l\'arrivée du chien, de choisir le compagnon qui correspond le mieux à votre mode de vie et d\'éviter certaines erreurs fréquentes. Mon objectif est de vous accompagner afin que l\'adoption soit une réussite durable pour vous comme pour le chien.'
        }
      ]
    },
    {
      section: '🐾 Pet Sitting',
      questions: [
        {
          question: 'Qu\'est-ce qu\'un pet sitter ?',
          answer: 'Un pet sitter est une personne de confiance qui s\'occupe de vos animaux (chiens, chats, NAC) à votre domicile ou chez lui lorsque vous êtes absent. Cela inclut la nourriture, les promenades, le jeu et le bien-être général.'
        },
        {
          question: 'Quelle est la différence entre un pet sitter et une pension ?',
          answer: 'Le pet sitting permet à votre animal de rester dans son environnement habituel, ce qui réduit le stress. En pension, les animaux sont accueillis en groupe, souvent dans un enclos ou un espace partagé.'
        },
        {
          question: 'Comment se déroule une garde d\'animaux ?',
          answer: 'Avant toute prestation, nous organisons une rencontre afin de mieux connaître vos habitudes et celles de votre animal. Pour un chien, j\'effectue également un test de compatibilité avec mes propres chiens afin d\'assurer une bonne entente. Ensuite, je prends soin de votre compagnon : promenades, repas, jeux, câlins. Pour les chats, je propose uniquement des visites à domicile, car ils sont territoriaux et se sentent plus à l\'aise dans leur environnement. Dans tous les cas, vous recevez régulièrement des nouvelles avec photos ou messages.'
        },
        {
          question: 'Puis-je avoir des nouvelles de mon animal pendant mon absence ?',
          answer: 'Bien sûr ! Je vous envoie des photos, vidéos ou messages selon votre préférence, et vous pouvez en demander à tout moment.'
        },
        {
          question: 'Quels animaux prenez-vous en charge ?',
          answer: 'Je m\'occupe principalement des chiens et des chats, mais aussi de certains petits animaux (lapins, cochons d\'Inde, chinchillas, etc.).'
        }
      ]
    },
    {
      section: '🔑 Questions pratiques',
      questions: [
        {
          question: 'Proposez-vous des activités complémentaires pour les chiens ?',
          answer: 'Oui ! Pour les clients ayant un contrat de garde ou d\'éducation, j\'organise des activités enrichissantes adaptées à tous les chiens : Balades collectives pour favoriser la socialisation et le bien-être, Initiation au mantrailing (recherche de personne) pour stimuler leur flair et renforcer la complicité maître-chien, Nosework (recherche d\'odeurs) pour développer leurs capacités de concentration et leur confiance. Ces activités sont ludiques, bienveillantes et contribuent à l\'équilibre physique et mental de votre compagnon.'
        },
        {
          question: 'Quels sont vos tarifs ?',
          answer: 'Mes tarifs varient selon la prestation (pet sitting, coaching, durée). Vous pouvez les retrouver sur mon site ou mes réseaux. N\'hésitez pas à me contacter, je me ferai un plaisir de vous renseigner.'
        },
        {
          question: 'Dans quelles zones intervenez-vous ?',
          answer: 'J\'interviens principalement dans la région lilloise et à la frontière belge (Toufflers, Lannoy, Lys-lez-Lannoy, Wasquehal, Wattrelos, Hem, Roubaix, Villeneuve-d\'Ascq, Leers, Mouscron, Estaimpuis, Néchin, Templeuve…). Je peux également me déplacer plus loin sur demande.'
        },
        {
          question: 'Êtes-vous assuré(e) ?',
          answer: 'Oui, je dispose d\'une assurance professionnelle pour garantir la sécurité de vos animaux.'
        }
      ]
    }
  ];

  let questionIndex = 0;

  return (
    <section className="faq">
      <h2 className="faq__title">Questions fréquentes</h2>
      <div className="faq__container">
        {faqData.map((section, sectionIndex) => (
          <div key={sectionIndex} className="faq__section">
            <h3 className="faq__section-title">{section.section}</h3>
            <div className="faq__questions">
              {section.questions.map((item, itemIndex) => {
                const currentIndex = questionIndex++;
                const isOpen = openIndex === currentIndex;
                
                return (
                  <div key={itemIndex} className="faq__item">
                    <button
                      className={`faq__question ${isOpen ? 'faq__question--open' : ''}`}
                      onClick={() => toggleQuestion(currentIndex)}
                      aria-expanded={isOpen}
                    >
                      <span className="faq__question-text">{item.question}</span>
                      <span className="faq__icon">{isOpen ? '−' : '+'}</span>
                    </button>
                    <div className={`faq__answer ${isOpen ? 'faq__answer--open' : ''}`}>
                      <p className="faq__answer-text">{item.answer}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;

